(function () {
  angular.module("akitabox.ui.dialogs.floor.delete", [
    "akitabox.core.constants",
    "akitabox.core.services.floor",
    "akitabox.core.toast",
  ]);
})();
